import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'

export const add_color = createAsyncThunk(
  'color/add_color',
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    try {
           const { data } = await api.post('/add-color', obj, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const get_colors = createAsyncThunk(
  'color/get_colors',
  async (
    { parPage, page, searchValue },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
      const { data } = await api.get(
        `/get-colors?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      )

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const color_update = createAsyncThunk(
  'color/color_update',
  async (
    obj,
    // { colorId, enName, kuName, arName },
    { rejectWithValue, fulfillWithValue }
  ) => {
    try {
     
      const { data } = await api.post('/color-update', obj, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

// End Method

export const colorReducer = createSlice({
  name: 'color',
  initialState: {
    successMessage: '',
    errorMessage: '',
    loader: false,
    packs: [],

    totalColors: 0,
    colorItem: '',
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add_color.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(add_color.rejected, (state, { payload }) => {
        state.loader = false
        state.errorMessage = payload.error
      })
      .addCase(add_color.fulfilled, (state, { payload }) => {
        state.loader = false
        state.successMessage = payload.message
        state.packs = [...state.packs, payload.colorItem]
      })

        .addCase(color_update.pending, (state, { payload }) => {
          state.loader = true
        })
        .addCase(color_update.rejected, (state, { payload }) => {
          state.loader = false
          state.errorMessage = payload.error
        })
        .addCase(color_update.fulfilled, (state, { payload }) => {
          state.loader = false
          state.colorItem = payload.colorItem 
          state.successMessage = payload.message
        })

      .addCase(get_colors.fulfilled, (state, { payload }) => {
        state.totalColors = payload.totalColors
        state.packs = payload.colors
      })
  },
})
export const { messageClear } = colorReducer.actions
export default colorReducer.reducer
